import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query imageConventionnequery {
        file(
          relativePath: {
            eq: "chirurgien-membre-superieur-conventionne-paris.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Chirurgien de la main et du membre supérieur conventionné (
          secteur 2) à Paris."
        css={css`
          margin-top: 25px;
        `}
      />
    )}
  />
)
